export class BusinessBrand {
  name?: string;
  value?: string;
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/pmclient-uat/src/app/shared/models/businessBrand.ts